function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndersonLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame 471"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    stroke: "#C4BFB6",
    style: {
      stroke: "#C4BFB6",
      stroke: "color(display-p3 0.7686 0.7490 0.7137)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 17.0004V6.99976H12.0006L2 17.0004Z",
    fill: "#F26924",
    style: {
      fill: "#F26924",
      fill: "color(display-p3 0.9490 0.4118 0.1412)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 17.0004V6.99976H11.9999L22 17.0004Z",
    fill: "#F26924",
    style: {
      fill: "#F26924",
      fill: "color(display-p3 0.9490 0.4118 0.1412)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 6.99976V17.0004H22L11.9999 6.99976Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0006 6.99976V17.0004H2L12.0006 6.99976Z",
    fill: "#001722",
    style: {
      fill: "#001722",
      fill: "color(display-p3 0.0000 0.0902 0.1333)",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndersonLogo);
export default __webpack_public_path__ + "static/media/andersonLogo.f6831d1453e4f0540a1c7d5c7a9b2997.svg";
export { ForwardRef as ReactComponent };